export enum MotionTrafficChartType {
  Motion_Count_Vs_Time = 1,
  Motion_Count_Vs_Sensor = 2,
  Motion_Count_Vs_LEVEL = 3,
  Motion_Count_Vs_LOCATION = 4,
}

export enum MotionHeatmapChartType {
  Motion_Count_Vs_Sensor = 1,
  Motion_Count_Vs_Level = 2,
  Motion_Count_Vs_Location = 3,
}

export enum AssetDisplayLevelChartType {
  Motion = 1,
  BurnTime = 2,
  Energy_Consumption_Sensor = 3,
}

export enum EnergyConsumptionChartType {
  Energy_Vs_Time = 1,
  Energy_Vs_Level = 2,
  Energy_Vs_Location = 3,
  Energy_Vs_Sensor = 4,
}
